import RouterSection from '@/Layout/components/RouterSection'

export default {
  path: '/',
  name: 'bizshop_home',
  component: RouterSection,
  mode: 'history',
  children: [
    // 비즈Shop
    {
      path: 'bizshop',
      name: 'bizshop',
      component: () => import('@/views/bizshop/Bizshop.vue'),
      beforeEnter: (to, from, next) => {
        // 필터가 열린 상태로 진입시 필터 닫기
        if(to?.query?.filter) {
          next({ ...to, query: { ...to.query, filter: undefined }})
          return
        }
        next();
      }
    },
    // 이벤트 기획전
    {
      path: 'eventlist',
      name: 'eventlist',
      component: () => import('@/views/bizshop/event/Eventlist')
    },
    // 이벤트상세
    {
      path: 'eventview',
      name: 'eventview',
      component: () => import('@/views/bizshop/event/Eventview')
    },
    // 이벤트 당첨자
    {
      path: 'eventann',
      name: 'eventann',
      component: () => import('@/views/bizshop/event/Eventann')
    },
    // 이벤트 질문
    {
      path: 'eventreport',
      name: 'eventreport',
      component: () => import('@/views/bizshop/event/Eventreport')
    },
  ]
}
